import React, { useState } from "react";
import { DropdownField, InputField, Text, View } from "../base";
import { TargetConfig, TargetType } from "../../utils/chartData";

interface TargetSelectionFieldProps {
  value: TargetConfig | null;
  onChange: (target: TargetConfig | null) => void;
  disabled?: boolean;
}

export const TargetSelectionField: React.FC<TargetSelectionFieldProps> = ({ value, onChange, disabled = false }) => {
  const [showExactInput, setShowExactInput] = useState(value?.type === "exact");

  const handleTypeChange = (type: string) => {
    const targetType = type as TargetType;
    if (targetType === "exact") {
      setShowExactInput(true);
      onChange({ type: targetType, value: value?.value || 0 });
    } else {
      setShowExactInput(false);
      onChange({ type: targetType });
    }
  };

  const handleExactValueChange = (newValue: string) => {
    const numValue = parseFloat(newValue) || 0;
    onChange({ type: "exact", value: numValue });
  };

  const targetTypeOptions = [
    { value: "maximize", label: "Maximize (Higher is Better)" },
    { value: "minimize", label: "Minimize (Lower is Better)" },
    { value: "exact", label: "Exact Target Value" },
  ];

  return (
    <View className="space-y-3">
      <View>
        <Text className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Target Configuration</Text>
        <DropdownField
          value={value?.type || ""}
          onChange={handleTypeChange}
          options={targetTypeOptions}
          placeholder="Select target type..."
          readOnly={disabled}
          className="w-full"
        />
      </View>

      {showExactInput && (
        <View>
          <Text className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Target Value</Text>
          <InputField
            type="number"
            value={value?.value?.toString() || "0"}
            onChange={handleExactValueChange}
            placeholder="Enter target value..."
            readOnly={disabled}
            className="w-full"
          />
        </View>
      )}

      {value && (
        <View className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
          <Text className="text-sm text-blue-700 dark:text-blue-300">
            <strong>Current Target:</strong>{" "}
            {value.type === "maximize"
              ? "Maximize the value (higher is better)"
              : value.type === "minimize"
                ? "Minimize the value (lower is better)"
                : `Target exact value: ${value.value}`}
          </Text>
        </View>
      )}
    </View>
  );
};
